import React, { useState } from "react";

export const PrivatePolicy = () => {
    return (
        <div>
            <h5>개인정보이용약관</h5>
        </div>
    );
}

export default PrivatePolicy;